/**
 * Product accordions: slide open/close animation + single-open (accordion) behavior.
 */
(function () {
  const DURATION = 400;

  function closeWithAnimation(details, onDone) {
    const content = details.querySelector('.accordion__content');
    if (!content) {
      details.removeAttribute('open');
      onDone?.();
      return;
    }
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion) {
      details.removeAttribute('open');
      onDone?.();
      return;
    }
    details.classList.add('accordion--closing');
    const done = () => {
      details.removeAttribute('open');
      details.classList.remove('accordion--closing');
      onDone?.();
    };
    content.addEventListener('transitionend', function handler(e) {
      if (e.target !== content || e.propertyName !== 'grid-template-rows') return;
      content.removeEventListener('transitionend', handler);
      done();
    });
    setTimeout(done, DURATION + 50);
  }

  function initProductAccordions() {
    document.querySelectorAll('section[id^="MainProduct-"]').forEach((section) => {
      const detailsList = section.querySelectorAll('.product__accordion details.product-accordion-details');
      const accordionSingle = section.querySelector('.product__accordion[data-accordion-single="true"]');

      detailsList.forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;

        summary.addEventListener('click', (e) => {
          const isOpen = details.hasAttribute('open');
          if (isOpen) {
            e.preventDefault();
            closeWithAnimation(details);
          } else {
            /* First-time open: force 0fr for one frame so slide-down transition runs */
            const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!reducedMotion) {
              e.preventDefault();
              details.setAttribute('open', '');
              details.classList.add('accordion--opening-start');
              requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                  details.classList.remove('accordion--opening-start');
                });
              });
            }
          }
        });

        if (accordionSingle && detailsList.length >= 2) {
          details.addEventListener('toggle', function accordionToggle() {
            if (!details.hasAttribute('open')) return;
            detailsList.forEach((other) => {
              if (other !== details && other.hasAttribute('open')) {
                closeWithAnimation(other);
              }
            });
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAccordions);
  } else {
    initProductAccordions();
  }
})();
